import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { EmptyData } from './../../commonLib/EmptyData'
import Moment from 'react-moment';
import { Spinner } from './../../commonLib/Spinner';
import { Container } from './../../base/Container';
import AppToaster from './../../commonLib/AppToaster';
import *as initOrderForProductionCrud from './../../_crud/initOrderForProductionCrud'
import *as productionUnitCrud from './../../_crud/productionUnitCrud'
import DatePicker from "react-datepicker";
import GetCurrentDateForSearch from './../../commonLib/dateFormat'
import { loadingMiniContext } from './../../commonLib/lodingMiniContext';
import { MyAlert } from './../../commonLib/MyAlert';
import { useParams } from 'react-router-dom';
import { PagingEmpty } from '../../commonLib/PagingEmpty';
import { UserView } from './../Global/Elements/UserView';
import { ProductView } from './../Global/Elements/ProductView';
import { StatusView } from './../../commonLib/StatusView';
import { GetEInitOrderStatusName } from './../../enumCollections/EInitOrderStatus';
import { GetEInitPriorityName } from './../../enumCollections/EInitPriority';
import ContactSelector from './../Global/ContactSelector';
import { ContactSelectorView } from './../Global/SelectorView/ContactSelectorView';
import { ProductionSelectorView } from './../Global/SelectorView/ProductionSelectorView';
import { loadingContext } from './../../commonLib/_lodingContext';
import { PAGING_PAGE_SIZE, getIsPrint } from '../../config/GlobalSettings';
import { ContactView } from '../Global/Elements/ContactView';
import { ProductionUnitView } from '../Global/Elements/ProductionUnitView';
import { Paging } from '../../commonLib/Paging';
import { PrintStarterDash } from '../Prints/PrintStaterDash';
import { InitOrderPrintMulti } from '../Prints/InitOrderPrintMulti';
import GetLoginInfo from '../../auth/_userContext/GetLoginInfo';
import { TextBoxTranslater } from '../../commonLib/TextBoxTranslater';

const initSentToOrder = {
    AllotedToContactId: "",
    ToProductionUnitId: "",
    Data: []
}
export function ManageInitOrderForProduction() {
    const [isLoading, setIsLoading] = useContext(loadingContext)
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)
    const [initOrder, setInitOrder] = useState([])
    const [isLoadingLocal, setIsLoadingLocal] = useState()
    const [selectedContactData, setSelectedContactData] = useState(undefined);
    const [production, setProduction] = useState([])
    const [sentToOrder, setSentToOrder] = useState(initSentToOrder)
    const [printToOrder, setPrintToOrder] = useState([])
    const [selectedProductionData, setSelectedProductionData] = useState(undefined);
    const [LastPage, setLastPage] = useState(1)
    const [pagingData, setPagingData] = useState()
    const userData = GetLoginInfo()

    const initValues = {
        Search: {
            searchTerm: "",
            pageNo: 1,
            pageSize: PAGING_PAGE_SIZE
        },
        Range: {
            fromDate: new Date(GetCurrentDateForSearch(-30)),
            toDate: new Date(GetCurrentDateForSearch(0))
        }
    }
    const [search, setSearch] = useState(initValues)

    function OnSearch() {
        SearchNew()
        setSentToOrder({ ...sentToOrder, Data: [] })
    }
    function SearchChange(e) {
        const value = e.target.value
        setSearch({ ...search, Search: { ...search.Search, searchTerm: value } })
    }
    function SearchNew() {
        if (userData.isWarehouse == 0) {
            getInitOrder()
        } else {
            getInitOrderWarehouse()
        }
    }

    function doRefresh(event) {
        setSearch({ ...search, Search: { ...search.Search, pageNo: 1 } })
        SearchNew()
        setTimeout(() => {
            event.target.complete();
        }, 1000);
        setSentToOrder({ ...sentToOrder, Data: [] })
    }

    const OnPageChange = (e) => {
        const { value } = e.target
        setSearch({ ...search, Search: { ...search.Search, pageNo: value } });
    }

    useEffect(() => {
        SearchNew()
    }, [])

    useEffect(() => {
        if (selectedContactData) {
            setSentToOrder({ ...sentToOrder, AllotedToContactId: selectedContactData.id })
            getProduction(selectedContactData.id)
        }
    }, [selectedContactData]);

    function getInitOrder() {
        setIsLoading(true);
        initOrderForProductionCrud.GetAll(search)
            .then(res => {
                if (res.data.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data.data
                        let paging = res.data.paging
                        setPagingData(paging)
                        setLastPage(paging.pageCount)
                        setInitOrder(hdata);
                        setIsLoading(false)
                    }
                    else {
                        setIsLoading(false)
                        let paging = res.data.paging
                        setPagingData(paging)
                        setLastPage(paging.pageCount)
                        setInitOrder([]);
                    }
                }
                else {
                    setIsLoading(false)
                    let paging = res.data.paging
                    setPagingData(paging)
                    setLastPage(paging.pageCount)
                    setInitOrder([]);
                    AppToaster('Network error', 'error')
                }
            })
            .catch(error => {
                setIsLoading(false);
                AppToaster(error, 'error')
            })
    }
    function getInitOrderWarehouse() {
        setIsLoading(true);
        initOrderForProductionCrud.GetAllWarehouse({ ...search, WarehouseId: userData.warehouseId })
            .then(res => {
                if (res.data.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data.data
                        let paging = res.data.paging
                        setPagingData(paging)
                        setLastPage(paging.pageCount)
                        setInitOrder(hdata);
                        setIsLoading(false)
                    }
                    else {
                        setIsLoading(false)
                        let paging = res.data.paging
                        setPagingData(paging)
                        setLastPage(paging.pageCount)
                        setInitOrder([]);
                    }
                }
                else {
                    setIsLoading(false)
                    let paging = res.data.paging
                    setPagingData(paging)
                    setLastPage(paging.pageCount)
                    setInitOrder([]);
                    AppToaster('Network error', 'error')
                }
            })
            .catch(error => {
                setIsLoading(false);
                AppToaster(error, 'error')
            })
    }
    function OnSentToOrder() {
        setIsLoadingLocal(true);
        initOrderForProductionCrud.SentToOrder(sentToOrder)
            .then(res => {
                if (res.data) {
                    if (res.data.succeeded) {
                        AppToaster('Total ' + sentToOrder.Data.length + ' init orders has been sent to orders', 'success')
                        setSentToOrder(initSentToOrder);
                        OnSearch()
                        setIsLoadingLocal(false)
                    }
                    else {
                        setIsLoadingLocal(false)
                        alert(JSON.stringify(res))
                    }
                }
                else {
                    setIsLoadingLocal(false)
                    AppToaster('Network error', 'error')
                }
            })
            .catch(error => {
                setIsLoadingLocal(false);
                AppToaster(error, 'error')
            })
    }

    const DeleteItem = (id) => {
        setIsLoading(true)
        initOrderForProductionCrud.Remove(id)
            .then(res => {
                if (res.data.succeeded) {
                    setIsLoading(false)
                    AppToaster('Deleted successfully.', 'success')
                    SearchNew()
                }
                else {
                    setIsLoading(false)
                    AppToaster('Using by someone,could not delete.', 'error')
                }

            }).catch(error => {
                setIsLoading(false)
                AppToaster('Network error', 'error')
            })
    }

    const checkDate = (date) => {
        var date1 = new Date(date);
        var date2 = new Date();
        if (date1 <= date2) {
            return "red bolder"
        }
        else { return "" }
    }
    function getProduction(contactid) {
        setIsLoadingMini(true);
        productionUnitCrud.GetByContactId(contactid)
            .then(res => {
                if (res.data.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data.data
                        setProduction(hdata);
                    }
                    else {
                        setProduction([]);
                        AppToaster("Server Error /Invalid Try.", 'error')
                    }
                }
                else {
                    setProduction([]);
                }
                setIsLoadingMini(false);
            })
            .catch(error => {
                setIsLoadingMini(false);
                AppToaster(error, 'error')
            })
    }

    const OnOrderSelect = (item) => {
        let a = item.id
        setSentToOrder({ ...sentToOrder, Data: [...sentToOrder.Data, a] })
        setPrintToOrder([...printToOrder, item])
    }
    const OnOrderRemove = (item) => {
        let data = sentToOrder.Data
        data.forEach((e, index) => {
            if (e == item.id)
                data.splice(index, 1)
        })
        setSentToOrder({ ...sentToOrder, Data: data })

        let printdata = printToOrder
        printdata.forEach((e, index) => {
            if (e.id == item.id)
                printdata.splice(index, 1)
        })
        setPrintToOrder([...printdata])
    }

    const OnSelectedChange = (e, item) => {
        const { checked } = e.target
        if (checked) {
            OnOrderSelect(item)
        } else {
            OnOrderRemove(item)
        }
    }
    const OnProductionChange = (e) => {
        const { value } = e.target;
        if (value) {
            production.forEach(element => {
                if (element.id == value) {
                    {
                        setSelectedProductionData(element)
                    }
                }
            });
        }
        else {
            setSelectedProductionData(undefined)
        }
    }

    useEffect(() => {
        if (selectedProductionData) {
            setSentToOrder({ ...sentToOrder, ToProductionUnitId: selectedProductionData.id })
        }
        else {
            setSentToOrder({ ...sentToOrder, ToProductionUnitId: "" })
        }
    }, [selectedProductionData])

    const printRef = useRef();
    return (
        <>
            {getIsPrint && <div style={{ display: "none" }}>
                <InitOrderPrintMulti printData={printToOrder} ref={printRef} />
            </div>}
            <Container title="Init Order for production unit" doRefresh={doRefresh} isBack="true">
                <div class="form-horizontal" >
                    <div className="row">
                        <div className="col-md-2">
                            <div class="form-group" style={{ marginLeft: "0", marginRight: "0" }}>
                                <span class="input-icon" style={{ width: "100%" }}>
                                    <DatePicker selectsStart startDate={search.Range.fromDate} endDate={search.Range.toDate} className="form-control input-date-padding" selected={search.Range.fromDate} onChange={(date) => setSearch({ ...search, Range: { ...search.Range, fromDate: date } })} />
                                    <i class="ace-icon fa fa-calendar blue"></i>
                                </span>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div class="form-group" style={{ marginLeft: "0", marginRight: "0" }}>
                                <span class="input-icon" style={{ width: "100%" }}>
                                    <DatePicker selectsEnd startDate={search.Range.fromDate} endDate={search.Range.toDate} className="form-control input-date-padding" selected={search.Range.toDate} onChange={(date) => setSearch({ ...search, Range: { ...search.Range, toDate: date } })} />
                                    <i class="ace-icon fa fa-calendar blue"></i>
                                </span>
                            </div>
                        </div>

                        <div className="col-md-5">
                            <div class="form-group" style={{ marginLeft: "0", marginRight: "0" }}>
                                <span class="input-icon" style={{ width: "100%" }}>
                                    <TextBoxTranslater style={{ paddingLeft: "24px" }} value={search.Search.searchTerm} onChange={SearchChange} className="form-control" type="text" placeholder="Search..." />
                                    <i class="ace-icon fa fa-search blue"></i>
                                </span>
                            </div>
                        </div>


                        <div className="col-md-1">
                            <div class="form-group" style={{ marginLeft: "0", marginRight: "0" }}>
                                <button onClick={OnSearch} to="/order/add" class="btn btn-sm btn-info pull-right">
                                    <i class="ace-icon fa fa-search bigger-110"></i>
                                    Run
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {sentToOrder.Data && sentToOrder.Data.length > 0 &&
                    <>
                        <div class="hr dotted"></div>
                        <div class="form-horizontal" >
                            <div className="row">
                                <div className="col-md-12">
                                    <h4>Select To Allot</h4>
                                </div>
                                <div className="col-md-5">
                                    <div class="form-group" style={{ marginLeft: "0", marginRight: "0" }}>
                                        <div class="col-xs-12">
                                            <label class="control-label no-padding-right">Contact</label>
                                            <ContactSelector searchtext="" setSelectedData={setSelectedContactData} />
                                        </div>
                                        <ContactSelectorView data={selectedContactData} />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div class="form-group" style={{ marginLeft: "0", marginRight: "0" }}>
                                        <div class="col-xs-12">
                                            <label class="control-label no-padding-right"> To Production Unit</label>
                                            <select className="form-control" name="ToProductionUnitId" value={sentToOrder.ToProductionUnitId} onChange={OnProductionChange}>
                                                <option value="" >Select...</option>
                                                {
                                                    production.map((data, index) =>
                                                        <option key={data.id} value={data.id}>{data.productionUnitName.toUpperCase()} ({data.id})</option>
                                                    )
                                                }
                                            </select>
                                            <ProductionSelectorView data={selectedProductionData} />

                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <div class="form-group" style={{ marginLeft: "0", marginRight: "0" }}>
                                        <label class="control-label">&#160;</label>
                                        {isLoadingLocal ?
                                            <button class="btn btn-sm btn-success pull-right" disabled>
                                                <i class="ace-icon fa fa-search bigger-110"></i>
                                                Sending...
                                            </button>
                                            :
                                            <button onClick={OnSentToOrder} class="btn btn-sm btn-success pull-right" disabled={(sentToOrder.AllotedToContactId && sentToOrder.ToProductionUnitId) ? false : true}>
                                                <i class="ace-icon fa fa-search bigger-110"></i>
                                                Sent To Order
                                            </button>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <div class="form-group" style={{ marginLeft: "0", marginRight: "0" }}>
                                        <label class="control-label"><br />&#160;</label>
                                        {getIsPrint && printToOrder && printToOrder.length > 0 &&
                                            <div class="btn-group">
                                                <PrintStarterDash printRef={printRef} />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                    </>
                }
                <Paging
                    pagingData={pagingData}
                    LastPage={LastPage}
                    CurrentPage={search.Search.pageNo}
                    OnPageChange={OnPageChange} >

                    {isLoading ?
                        <Spinner />
                        :
                        initOrder && initOrder.length > 0 ?
                            <div className="tables-scroll">
                                <table className="table table-hover table-bordered">
                                    <thead>
                                        <tr>
                                            <th ></th>
                                            <th>#Id</th>
                                            <th>On Date</th>
                                            <th>Due Date</th>
                                            <th>Alloted For</th>
                                            <th>For Production</th>
                                            <th>Product</th>
                                            <th>Configuration</th>
                                            <th>Quantity</th>
                                            <th>Priority</th>
                                            <th>Details</th>
                                            <th>By</th>
                                            <th style={{ width: "43px" }}></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {initOrder.map((item, index) =>
                                            <tr key={item.id} className={sentToOrder.Data.includes(item.id) ? "active" : ""} >
                                                <td>
                                                    <div class="checkbox">
                                                        <label>
                                                            <input name="form-field-checkbox" class="ace ace-checkbox-2" type="checkbox" onChange={(e) => OnSelectedChange(e, item)} />
                                                            <span class="lbl"></span>
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>{item.id}</td>
                                                <td><div style={{ width: "70px" }}><Moment format="DD-MMM-YYYY">{item.onDate}</Moment></div></td>
                                                <td><div style={{ width: "70px" }} className={checkDate(item.dueDate)}><Moment format="DD-MMM-YYYY">{item.dueDate}</Moment></div></td>
                                                <td>
                                                    <Link to={"/contact/dashboard/" + item.allotedForContactId}>
                                                        <ContactView item={item.contact} uid={"C" + index} />
                                                    </Link>
                                                </td>
                                                <td><Link to={"/productionunit/dashboard/" + item.forProductionUnitId}>
                                                    <ProductionUnitView item={item.forProductionUnitData} />
                                                </Link></td>
                                                <td><Link to={"/product/dashboard/" + item.product.id}>
                                                    <ProductView item={item.product} uid={"PP" + index} />
                                                </Link></td>
                                                <td>
                                                    {item.productionConfiguration ?
                                                        <Link to={"/productionunit/configuration/dashboard/" + item.productionConfiguration.id}>
                                                            {item.productionConfiguration.name}
                                                        </Link>
                                                        :
                                                        "NA"
                                                    }
                                                </td>
                                                <td>{item.quantity} {item.unit}</td>
                                                <td><span class={item.priority == 1 ? "label label-sm label-info" : "label label-sm label-danger"}>{GetEInitPriorityName(item.priority)}</span></td>
                                                <td><div style={{ width: "200px" }}>{item.details}</div></td>
                                                <td>
                                                    <UserView item={item.createdByUser} uid={"D" + index} createdOn={item.createdOn} />
                                                </td>
                                                <td>
                                                    <div class="btn-group">
                                                        <MyAlert confirmBtnText="Yes, delete it!" title="Delete" onConfirm={DeleteItem} param={item.id}>
                                                            <i class="ace-icon fa fa-trash-o bigger-120"></i>
                                                        </MyAlert>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <EmptyData>
                                No records found.
                                <br />
                                <br />
                            </EmptyData>
                    }
                </Paging>
            </Container >
        </>
    )
}
